// extracted by css-extract-rspack-plugin
export default {"EmptyMessage":"PendingChecksBody-module__EmptyMessage__nIPt4"};